import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const WLiveItem = styled.div`
  position: relative;

  .video-wrap {
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    height: ${mixin.pxToVw('512')};

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 52.88%,
        rgba(0, 0, 0, 0.3) 74.25%
      );
    }

    .xgplayer {
      background-color: transparent;
    }

    .xgplayer,
    .ready-img {
      height: ${mixin.pxToVw('512')};
    }
  }

  .video-info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${mixin.flex({
      direction: 'column',
      align: 'center',
      justify: 'space-between',
    })};
    z-index: 1;

    .title {
      margin-top: 6px;
    }

    .desc {
      margin-top: 6px;
    }

    .btn {
      margin-top: 17px;
      width: 200px;
      height: 44px;
      font-weight: 600;
      font-size: 15px;
      border-radius: 30px;
      background: #fff;
      gap: 0 8px;

      &.btn-alarm {
        color: #ff4600;

        &.active {
          background: #ccc;
          color: #fff;

          svg path {
            stroke: #fff;
          }
        }
      }

      &.btn-live {
        background: #ff4600;
        color: #fff;

        svg path {
          stroke: #fff;
        }
      }
    }

    .video-info-top {
      width: 100%;
      ${mixin.flex({ align: 'flex-start', justify: 'space-between' })};
      padding: 12px 12px 0;
    }

    .video-info-bottom {
      padding: 25px;
      text-align: center;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .video-wrap {
      border-radius: ${mixin.pxToVw('20')};
    }

    .video-info {
      .title {
        margin-top: ${mixin.pxToVw('6')};
      }

      .desc {
        margin-bottom: ${mixin.pxToVw('6')};
      }

      .btn {
        margin-top: ${mixin.pxToVw('17')};
        width: ${mixin.pxToVw('200')};
        height: ${mixin.pxToVw('44')};
        font-size: ${mixin.pxToVw('15')};
        border-radius: ${mixin.pxToVw('30')};
        gap: ${mixin.pxToVw('0 8')};
      }

      .video-info-top {
        padding: ${mixin.pxToVw('12 12 0')};
      }

      .video-info-bottom {
        padding: ${mixin.pxToVw('25')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 600px;

    .bg-img {
      height: 100%;

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(40px);
      }
    }

    .ly-pc {
      ${mixin.flex({
        direction: 'row-reverse',
        justify: 'space-between',
      })};
      gap: 64px;
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
    }

    .video-wrap {
      width: 418px;
      height: 557px;
      border-radius: 24px;
      flex-shrink: 0;

      .xgplayer,
      .ready-img {
        height: 557px;
      }

      .play-icon {
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 1;
      }
    }

    .video-info {
      display: block;
      height: auto;
      position: relative;
      white-space: nowrap;
      max-width: 720px;
      overflow: hidden;

      .title {
        margin-top: 0;
      }

      .desc {
        margin-top: 18px;
      }

      .btn {
        margin-top: 52px;
        width: 221px !important;
        height: 56px;
        font-weight: 500;
        font-size: 17px;
      }

      .video-status {
        ${mixin.flex({ justify: 'flex-start' })};
        gap: 0 12px;
        margin-bottom: 12px;

        .prsnl-tag {
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
`;
